import React, { useEffect, useState } from 'react'
import { dispatchTag } from '../../../store/analytics/analytics.actions'
import { TAG_MULTIPATH_CTA } from '../../../store/analytics/analytics.actionTypes'
import { hideMapTooSlowTooltip, setMapTooSlowTimestamp } from '../../../store/ui/ui.actions'
import { selectMapTooSlowTooltip } from '../../../store/ui/ui.selectors'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { withOnlyGE } from '../../Device'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './MapTooSlowTooltip.less'
import classNames from 'classnames'

const MapTooSlowTooltip = () => {
  const execHideMapTooSlowTooltip = useAction(hideMapTooSlowTooltip)
  const execSetLastMapTooSlowTimestamp = useAction(setMapTooSlowTimestamp)
  const [visible, setVisible] = useState(true)

  const closeTooltip = useEventCallback(() => {
    execHideMapTooSlowTooltip()
  }, [execHideMapTooSlowTooltip])

  const execDispatchTag = useAction(dispatchTag)

  useEffect(() => {
    execDispatchTag({
      type: TAG_MULTIPATH_CTA,
      tagInfo: { tag: PUB_TAG.PUB_MAP_POP_IN_MAP_TOO_SLOW },
      isImpression: true
    })
    execSetLastMapTooSlowTimestamp()
    setTimeout(() => setVisible(false), 5000)
  }, [])

  return (
    <div className={classNames(s.root, !visible ? s.hide : '')} onClick={closeTooltip}>
      <div className={s.content}>
        <p>
          <T id={'map.tools.tooSlowToolip.title'} />
        </p>
        <p>
          <T id={'map.tools.tooSlowToolip.text'} />
        </p>
      </div>
      <div className={s.closeButton}>
        <SVGIcon icon={'croix-android'} />
      </div>
    </div>
  )
}
export default withOnlyGE(withEverySelectorTruthy(selectMapTooSlowTooltip)(MapTooSlowTooltip))
